const Credits = () => {

    return (
        <div>
            <h3>A special thanks to the following, that have in some shape or form developed code or images that have
                helped enable this website: </h3>
            <a href="//commons.wikimedia.org/wiki/User:Cburnett">Cburnett, for the chess pieces</a>
            <a href="https://www.svgbackgrounds.com/elements/animated-svg-preloaders/">Animated SVG Preloaders by
                SVGBackgrounds.com</a>
        </div>
    )
}

export default Credits;